<div class="payment-container p-15 d-flex flex-column align-items-center">
    <div class="dismiss-hint"></div>
    <h4 class="text-center"><span class="main-color">92% of users</span> stay with us after initial 30-day subscription</h4>

    <div *ngIf="isLoading" class="w-100 d-flex p-30 justify-content-center">
        <mat-progress-spinner mode="indeterminate" diameter='50'></mat-progress-spinner>
    </div>

    <form #stripeForm class="w-100 d-flex flex-column mt-10" [class.hidden]="isLoading">
        <!-- <h5 class="text-center">Enter payment method</h5> -->
        <div #stripeEmail class="mb-20" *ngIf="!email">
            <!-- <span *ngIf="email" class="gray-color">Email: {{email}}</span> -->
        </div>
        <div #expressCheckout *ngIf="isExpressMethodsAvailable"></div>
        <div class="text-center fs-14 mt-10" *ngIf="isExpressMethodsAvailable">Or enter card details:</div>
        <div #stripeElement class="mt-5"></div>
        <button mat-flat-button class="fw-semibold w-100 mt-25 purchase">{{purchaseButtonTitle}}</button>
        <div *ngIf="isDisclaimerShown" class="text-hint mt-20">We’ve automatically applied discount to your first subscription price. You will be charged {{product.priceLabel}}. Please note that your subscription will be automatically renewed at full price of {{product.fullPriceLabel}} at the end of chosen subscription term. Terms and Conditions apply. If you want to manage your subscription, you may do so via your personal account.</div>
    </form>
</div>